/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { HealthCareFilter } from '../../Components/Forms';
import { SectionHeading } from '../../Components/SectionHeading';
import { RightArrow } from '../../Components/icons';
import { AnchorLink, FloatingBtn, RoundButton } from '../../Components/button';
import { SimpleSlider } from '../../Components/sliders';
import ProfileCard from '../../Components/Card/ProfileCard/profileCard';
// import MonitorHealthSection from './monitorHealthSection/MonitorHealthSection';
import HealthConditions from './healthConditions/HealthConditions';
import DiscoverWellnesstopics from './discoverWellnessTopics/DiscoverWellnesstopics';
// import BloodPressureMonitor from './bloodPressureMonitor/BloodPressureMonitor';
import RecomendedDoc from './recomendedDoc/RecomendedDoc';
// import ExploreMoreHealthConditions from
// './exploreHealthMoreConditions/ExploreMoreHealthConditions';
import TypingAnimation from '../../Components/typingAnimation/TypingAnimation';
import MainBanner from '../../Components/mainBannerComponent/MainBanner';
import TopReads from './topReads/TopReads';
import Layouts from '../../layouts/Layouts';
import img from '../../assets/images/svg/doc.svg';
import FinDocByDisease from './findDocByDisease/FinDocByDisease';
import ConsultWithDoctor from './consultWithDoctor/ConsultWithDoctor';
// import API from '../../api';

const cardsData = [
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  }
];

const btnTitle = [
  'Kidney Stones',
  'Allergies',
  'Depression',
  'Hair Loss',
  'Vaccines',
  'Kidney Stones',
  'Allergies',
  'Depression',
  'Hair Loss',
  'Vaccines'
];

function HomePage() {
  const user = useSelector((state) => state.Test.users);
  console.log(user);

  const buttons = btnTitle.map((button, index) => (
    <RoundButton text={button} key={index} />
  ));

  const items = cardsData.map((card, index) => (
    <ProfileCard card={card} key={index + 1} />
  ));

  useEffect(() => {
    // const result = API.get('todos/5');
    // console.log(result);
  }, []);

  return (
    <Layouts>
      <section className="homepage mainBannerPage">
        <MainBanner />
        <SectionHeading
          heading="Find the best"
          colorHeading={<TypingAnimation />}
          icon={<RightArrow />}
          link={<AnchorLink to="/" text="Browse" />}
        />
        <HealthCareFilter />
        <SimpleSlider
          className="profileSlider"
          sliderTitle="Top Rated General Physicians"
        >
          {items}
        </SimpleSlider>
        {/* <MonitorHealthSection /> */}
        <HealthConditions />
        <SimpleSlider sliderTitle="Explore topics">{buttons}</SimpleSlider>
        <DiscoverWellnesstopics />
        <FinDocByDisease />
        <ConsultWithDoctor />
        {/* <BloodPressureMonitor /> */}
        <TopReads />
        {/* <ExploreMoreHealthConditions /> */}
        <RecomendedDoc />
        <FloatingBtn />
      </section>
    </Layouts>
  );
}

export default HomePage;
